import { AppBar, Dialog, Divider, IconButton, List, ListItemButton, ListItemText, Slide, Toolbar, Typography } from "@mui/material";
import React, { forwardRef, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function SelectMeal({ open, pendingMeals, itemSelected, title, selectedSetupId }) {

  const itemRefs = useRef(new Map());

  const handleClose = () => {
    itemSelected();
  }

  const handleEntered = () => {
    if (selectedSetupId == null) return;
    itemRefs.current.get(selectedSetupId)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  const renderMeals = () => {
    const uiArray = [];

    pendingMeals?.forEach((meal, idx) => {
      const setupId = meal.queuedSetups?.[0]?.id;
      const isSelected = selectedSetupId != null && setupId === selectedSetupId;

      uiArray.push(
        <ListItemButton
          key={`list${meal.mealId}${dayjs(meal.diningDate).format("MM-DD")}`}
          ref={(el) => {
            if (el) itemRefs.current.set(setupId, el);
            else itemRefs.current.delete(setupId);
          }}
          sx={isSelected ? { backgroundColor: "#e0e0e0" } : undefined}
          onClick={() => itemSelected(setupId, `${meal?.mealName} (${dayjs(meal?.diningDate).format('ddd [-] MM/DD/YYYY')})`)}>
          <ListItemText fontWeight="bold" primary={`${meal?.mealName} (${dayjs(meal?.diningDate).format('ddd [-] MM/DD/YYYY')})`} />
        </ListItemButton>
      );

      if (idx < pendingMeals?.length - 1) {
        uiArray.push(<Divider key={`divider${meal.mealId}${dayjs(meal.diningDate).format("MM-DD")}`} />)
      }
    });

    return uiArray;
  } 

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      TransitionProps={{ onEntered: handleEntered }}>
        <AppBar position="static">
          <Toolbar>
            <IconButton color="inherit" onClick={handleClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" fontWeight="bold" color="inherit" sx={{marginLeft: ".25rem"}}>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
        <List>
          {renderMeals()}
        </List>

      </Dialog>
  );
}